import * as React from 'react';
import {DefaultButton, PrimaryButton, Toggle} from '@fluentui/react';
import { TextField } from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";

function EditChecklistItem(props) {
    const [user] = useContext(AuthContext);
    const [item, setItem] = useState('');
    const [isDefault, setIsDefault] = useState(true);

    const _submit = (e) => {
        e.preventDefault();
        const data = {item: item, default: isDefault};
        fetch(`/api/checklist/${props.edit.id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='EditChecklistItem'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        setItem(props.edit.item || '');
        setIsDefault(props.edit.default  || false);
    }, [props.edit])

    var optionalProps = {};
    if (isDefault) optionalProps.defaultChecked = true;

    return (
        <Panel
            isOpen={props.edit}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Punkt Kontrolny"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='EditChecklistItem'>
                <TextField required autoFocus label='Nazwa' value={item} onChange={(e) => setItem(e.target.value || '')}/>
                <Toggle label="Domyślny" {...optionalProps} onText="Tak" offText="Nie" onChange={(e, checked) => setIsDefault(checked)} />
            </form>
        </Panel>
    )
}

export default EditChecklistItem;